import { withStyles } from '@material-ui/core/styles';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { getProposedDealsByCampaignId } from '../../store/selectors/deals';

const styles = theme => ({
  workflowContainer: {
    height: '60px',
    marginBottom: '40px',
    marginLeft: '60px'
  },
  workflowStart: {
    clipPath: 'polygon(0 0, 75% 0, 82% 50%, 75% 100%, 0% 100%)',
    paddingLeft: '40px'
  },
  workflowMiddle: {
    clipPath: 'polygon(75% 0%, 82% 50%, 75% 100%, 0% 100%, 7% 50%, 0% 0%)',
    marginLeft: '-7.3%',
    paddingLeft: '40px'
  },
  workflowEnd: {
    clipPath: 'polygon(75% 0%, 75% 50%, 75% 100%, 0% 100%, 7% 50%, 0% 0%)',
    marginLeft: '-7.3%',
    paddingLeft: '80px'
  },
  workflowItem: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    background: 'white',
    width: '30%',
    height: '100%',
    color: 'black',
    fontWeight: 'bold',
    '&:hover': {
      color: '#22c26e'
    }
  },
  workflowItemSelected: {
    background: '#22c26e',
    color: 'white',
    '&:hover': {
      color: 'white'
    }
  },
  workflowPaper: {
    height: '60px',
    width: '500px',
    background: '#f5f6fa',
    position: 'absolute',
    marginLeft: '60px',
    width: '85%'
  },
  headerContainer: {
    position: 'relative'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/CampaignNavBar.enhancer.js